import { Component } from '@angular/core';

@Component({
  selector: 'app-envasado-no-selected',
  templateUrl: './envasado-no-selected.component.html',
  styleUrls: ['./envasado-no-selected.component.css'],
})
export class EnvasadoNoSelectedComponent {}
